/**
 * @desc 导出物流箱单记录
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(cbNo: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/exportTrackWlxReport/${cbNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
